import React from 'react'
import Header from './Header'
import Main from './Main'

const App = () => (
  <div>
    <Header />
    <Main />
  </div>
)

export default App



// WEBPACK FOOTER //
// ./src/components/App.js